/** True only while scripts/prerender.js is capturing pages. Use only to skip side effects. */
export function isPrerendering() {
  if (typeof window === "undefined") return false;
  return window.__MAG_PRERENDER__ === true;
}
